import React, { useEffect, useState } from 'react'
import Banner from './Banner/Banner'
import ChooseUs from './ChooseUs/ChooseUs'
import Image from './Image/Image'
import OurProducts from './OurProducts.js'
import ImageTwo from './Image-Two/ImageTwo.js'
import PartnersTabs from './PartnersTabs/index.js'
import About from './About/index.js'
import Mobile from './Mobile/index.js'
import Accordian from './Accordian/Accordian.js'
import TestimonialComponent from './Testimonials/TestimonialComponent.js'
import Testimonial from './Testimonials/Testimonial.js'
import HowItWorks from '../PospComp/HowItWorks.js'
import WhyChooseUs from './WhyChooseUs/WhyChooseUs.js'
import Genesis from './Genesis/Genesis.js'
import HowWeCanHelp from './HowWeCanHelp/HowWeCanHelp.js'
import OurPartnersBPN from './OurPatner/OurPartnersBPN.js'

function HomePage() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
        };

        // Set initial mobile state on component mount
        handleResize();

        // Add resize event listener to update mobile state
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            <Banner />
            <WhyChooseUs/>
            {/* <Genesis/> */}
            <HowWeCanHelp/>
            <OurPartnersBPN/>
            {/* <ChooseUs />
            <Image />
            <HowItWorks />
            <OurProducts />
            <ImageTwo />
            <PartnersTabs />
            <About />
            <Mobile /> */}
            {/* <TestimonialComponent/> */}
            {/* <Testimonial pages={isMobile ? '1' : '3'} />
            <Accordian /> */}

        </>
    )
}

export default HomePage